exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ScreenTakeOverMessage {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 50;\n  padding: 40px;\n  background: #0068e9; }\n  .ScreenTakeOverMessage-content * {\n    color: #fefefe; }\n  .ScreenTakeOverMessage-content {\n    max-width: 400px; }\n  .ScreenTakeOverMessage h1 {\n    margin-bottom: 0; }\n  .ScreenTakeOverMessage a {\n    border-bottom: 1px dotted rgba(254, 254, 254, 0.5); }\n    .ScreenTakeOverMessage a:hover {\n      border-bottom-color: #fefefe;\n      color: #fefefe; }\n", ""]);

// exports
